
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'
import {CURRENT_USER_SET_SITE_ID} from 'redux/modules/currentUser'

export const CATEGORY_MAPPINGS = loadTypes('CATEGORY_MAPPINGS')
export const ADD_CATEGORY_MAPPING = loadTypes('ADD_CATEGORY_MAPPING')
export const REMOVE_CATEGORY_MAPPING = loadTypes('REMOVE_CATEGORY_MAPPING')

export const CHANNEL_MAPPINGS = loadTypes('CHANNEL_MAPPINGS')

export const URL_MAPPINGS = loadTypes('URL_MAPPINGS')
export const UNMAPPED_URLS = loadTypes('UNMAPPED_URLS')
export const DELETE_MAPPED_URL = loadTypes('DELETE_MAPPED_URL')
export const MAP_UNMAPPED_URL = loadTypes('MAP_UNMAPPED_URL')

export const REFERRER_MAPPINGS = loadTypes('REFERRER_MAPPINGS')
export const UNMAPPED_REFERRERS = loadTypes('UNMAPPED_REFERRERS')
export const DELETE_MAPPED_REFERRER = loadTypes('DELETE_MAPPED_REFERRER')
export const MAP_UNMAPPED_REFERRER = loadTypes('MAP_UNMAPPED_REFERRER')

export const UTM_MAPPINGS = loadTypes('UTM_MAPPINGS')
export const UNMAPPED_UTMS = loadTypes('UNMAPPED_UTMS')
export const DELETE_MAPPED_UTM = loadTypes('DELETE_MAPPED_UTM')
export const MAP_UNMAPPED_UTM = loadTypes('MAP_UNMAPPED_UTM')

export const UNMAPPED_IMPRESSIONS = loadTypes('UNMAPPED_IMPRESSIONS')

function mappingsReducer(state = {}, mappings) {
  return {
    ...state,
    ...mappings
  }
}

function processMappings(request, response) {
  const {category} = request.queryParams

  return {
    [category]: response
  }
}

function processChannelMappings(request, response) {
  return response.reduce((acc, mapping) => {
    const {dv_chgroup: channelGroupId, dv_channel: channelId} = mapping.channel
    acc[`${channelGroupId}/${channelId}`] = mapping.mappings
    return acc
  }, {})
}

const initialState = {
  mappings: null,
  channelMappings: null,
  unmappedChannels: null,

  isMappingsFetching: false,
  isMappingsFetchingErrorMessage: false,

  isChannelMappingsFetching: false,
  isChannelMappingsFetchingErrorMessage: false,


  isUnmappedUrlFetching: false,
  isUnmappedUrlFetchingErrorMessage: false,

  isMapUnmappedChannelSaving: false,
  isMapUnmappedChannelSavingErrorMessage: false,

  isReferrerUnmappingsFetching: false,
  isReferrerUnmappingsFetchingErrorMessage: false,
  isReferrerMappingFetching: false,
  isReferrerMappingFetchingErrorMessage: false,

  isUtmUnmappingsFetching: false,
  isUtmUnmappingsFetchingErrorMessage: false,
  isUtmMappingFetching: false,
  isUtmMappingFetchingErrorMessage: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case CATEGORY_MAPPINGS.REQUEST:
      return {
        ...state,
        isMappingsFetching: true
      }

    case CATEGORY_MAPPINGS.SUCCESS:
      return {
        ...state,
        isMappingsFetching: false,
        mappings: mappingsReducer(
          state.mappings,
          processMappings(action.request, action.response)
        )
      }

    case CATEGORY_MAPPINGS.FAILURE:
      return {
        ...state,
        isMappingsFetching: false,
        isMappingsFetchingErrorMessage: action.message
      }

    case ADD_CATEGORY_MAPPING.REQUEST:
      return {
        ...state,
        isMappingsFetching: true
      }

    case ADD_CATEGORY_MAPPING.SUCCESS:
      return {
        ...state,
        isMappingsFetching: false
      }

    case ADD_CATEGORY_MAPPING.FAILURE:
      return {
        ...state,
        isMappingsFetching: false,
        isMappingsFetchingErrorMessage: action.message
      }

    case REMOVE_CATEGORY_MAPPING.REQUEST:
      return {
        ...state,
        isMappingsFetching: true
      }

    case REMOVE_CATEGORY_MAPPING.SUCCESS:
      return {
        ...state,
        isMappingsFetching: false
      }

    case REMOVE_CATEGORY_MAPPING.FAILURE:
      return {
        ...state,
        isMappingsFetching: false,
        isMappingsFetchingErrorMessage: action.message
      }

    case CHANNEL_MAPPINGS.REQUEST:
      return {
        ...state,
        isChannelMappingsFetching: true
      }

    case CHANNEL_MAPPINGS.SUCCESS:
      return {
        ...state,
        isChannelMappingsFetching: false,
        channelMappings: mappingsReducer(
          state.channelMappings,
          processChannelMappings(action.request, action.response)
        )
      }

    case CHANNEL_MAPPINGS.FAILURE:
      return {
        ...state,
        isChannelMappingsFetching: false,
        isChannelMappingsFetchingErrorMessage: action.message
      }

    case UNMAPPED_URLS.REQUEST:
      return {
        ...state,
        isUnmappedUrlFetching: true
      }
    case UNMAPPED_URLS.SUCCESS:
      return {
        ...state,
        isUnmappedUrlFetching: false,
        unmappedUrls: action.response
      }
    case UNMAPPED_URLS.FAILURE:
      return {
        ...state,
        isUnmappedUrlFetching: false,
        isUnmappedUrlFetchingErrorMessage: action.message
      }
    case UNMAPPED_REFERRERS.REQUEST:
      return {
        ...state,
        isReferrerUnmappingsFetching: true
      }
    case UNMAPPED_REFERRERS.SUCCESS:
      return {
        ...state,
        isReferrerUnmappingsFetching: false,
        unmappedReferrers: action.response
      }
    case UNMAPPED_REFERRERS.FAILURE:
      return {
        ...state,
        isUtmUnmappingsFetching: false,
        isUtmUnmappingsFetchingErrorMessage: action.message
      }

    case UNMAPPED_UTMS.REQUEST:
      return {
        ...state,
        isUtmUnmappingsFetching: true
      }
    case UNMAPPED_UTMS.SUCCESS:
      return {
        ...state,
        isUtmUnmappingsFetching: false,
        unmappedUtms: action.response
      }
    case UNMAPPED_UTMS.FAILURE:
      return {
        ...state,
        isUtmUnmappingsFetching: false,
        isUtmUnmappingsFetchingErrorMessage: action.message
      }

    case UNMAPPED_IMPRESSIONS.REQUEST:
      return {
        ...state,
        isUnmappedImpressionFetching: true
      }
    case UNMAPPED_IMPRESSIONS.SUCCESS:
      return {
        ...state,
        isUnmappedImpressionFetching: false,
        unmappedImpressions: action.response
      }
    case UNMAPPED_IMPRESSIONS.FAILURE:
      return {
        ...state,
        isUnmappedImpressionFetching: false,
        isUnmappedImpressionFetchingErrorMessage: action.message
      }

    case URL_MAPPINGS.REQUEST:
      return {
        ...state,
        isUrlMappingFetching: true
      }
    case URL_MAPPINGS.SUCCESS:
      return {
        ...state,
        isUrlMappingFetching: false,
        urlMappings: action.response
      }
    case URL_MAPPINGS.FAILURE:
      return {
        ...state,
        isUrlMappingFetching: false,
        isUrlMappingFetchingErrorMessage: action.message
      }
    case REFERRER_MAPPINGS.REQUEST:
      return {
        ...state,
        isReferrerMappingFetching: true
      }
    case REFERRER_MAPPINGS.SUCCESS:
      return {
        ...state,
        isReferrerMappingFetching: false,
        referrerMappings: action.response
      }
    case REFERRER_MAPPINGS.FAILURE:
      return {
        ...state,
        isReferrerMappingFetching: false,
        isReferrerMappingFetchingErrorMessage: action.message
      }
    case UTM_MAPPINGS.REQUEST:
      return {
        ...state,
        isUtmMappingFetching: true
      }
    case UTM_MAPPINGS.SUCCESS:
      return {
        ...state,
        isUtmMappingFetching: false,
        utmMappings: action.response
      }
    case UTM_MAPPINGS.FAILURE:
      return {
        ...state,
        isUtmMappingFetching: false,
        isUtmMappingFetchingErrorMessage: action.message
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/settings/index.js